import * as actionTypes from '../../redux/actionTypes';

const initialState = {
  scheduled: [],
  error: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SCHEDULED_PAYMENTS_LOADED:
      return { ...state, ...initialState, ...action.data };
    default:
      return state;
  }
};
